export const SEGUKIDS = {
  codProducto: "SEGUKIDS",
  prodCodigoCore: 'SKT',


  urls: {
    cotizacion: "/kids/cotizacion",
    asegurado: "/kids/asegurado",
    contratante: "/kids/contratante",
    cotizador: "/kids/cotizador",
    planes: "/kids/planes",
    formaPago: "/kids/pago",
    pagador:"/kids/pagador",
    recuperar:"/recuperar-cotizacion-segukids",
    poliza:"/kids/recuperar-poliza"

  },
};
